import { Button } from "@newsela/angelou";
import { LoadingSpinner } from "@newsela/angelou";

import {
  stateContainerCss,
  stateTitleCss,
  stateSubtitleCss,
  actionButtonCss,
} from "../LessonPlannerErrorState/LessonPlannerErrorState.style";
import { loadingSpinnerCss } from "./LessonPlannerLoadingState.style";

interface LessonPlannerLoadingStateProps {
  onCancel: () => void;
}

const LessonPlannerLoadingState = ({
  onCancel,
}: LessonPlannerLoadingStateProps) => {
  return (
    <div css={stateContainerCss}>
      <div css={loadingSpinnerCss}>
        <LoadingSpinner />
      </div>
      <div css={stateTitleCss}>Preparing your lesson plan</div>
      <div css={stateSubtitleCss}>
        This may take a few seconds. Please wait.
      </div>
      <Button
        flavor={Button.flavors.tertiary}
        onClick={onCancel}
        __cssFor={actionButtonCss}
      >
        Cancel
      </Button>
    </div>
  );
};

export default LessonPlannerLoadingState;
